import { dealerApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const dealerSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const DEALERS_ACTION_TYPE = createNamedActions('dealers', {
  GET_DEALERS: 'GET_DEALERS',
  CREATE_DEALER: 'CREATE_DEALER',
  EDIT_DEALER: 'EDIT_DEALER',
  DELETE_DEALER: 'DELETE_DEALER',
});

export const getDealersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await dealerApi.getDealers(params);

  return dispatch({
    type: DEALERS_ACTION_TYPE.GET_DEALERS,
    payload: normalize(data, [dealerSchema]).entities.data,
  });
});

export const createDealerAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await dealerApi.createDealer(params);

  return dispatch({
    type: DEALERS_ACTION_TYPE.CREATE_DEALER,
    payload: data,
  });
});

export const editDealerAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await dealerApi.editDealer(params);

  return dispatch({
    type: DEALERS_ACTION_TYPE.EDIT_DEALER,
    payload: data,
  });
});

export const deleteDealerAction = catchAsyncActionError(params => async dispatch => {
  await dealerApi.deleteDealer(params);

  return dispatch({
    type: DEALERS_ACTION_TYPE.DELETE_DEALER,
    meta: params,
  });
});
